import { ReactElement, memo } from 'react';

import { OrderClientInfoProps } from './types';
import OrderClientInfoTitle from './Title';
import OrderClientInfoDescription from './Description';
import { OrderClientInfoContainer } from './styles';

const OrderClientInfo = ({
  name,
  trackingCode,
  itemTypeId,
  hasError = false,
  duplicated = false,
}: OrderClientInfoProps): ReactElement => (
  <OrderClientInfoContainer>
    <OrderClientInfoTitle title={name} hasError={hasError} />

    <OrderClientInfoDescription
      description={trackingCode}
      itemTypeId={itemTypeId}
      duplicated={duplicated}
    />
  </OrderClientInfoContainer>
);

export default memo(OrderClientInfo);
